import React, { useState } from 'react';
import {withRouter} from 'react-router-dom';
import styles from "./IndividualnterStateDecision.module.scss";
import {Button, RadioSelector, ErrorMsg} from "@onegovbugs/onegov-react-components";
import {useSelector, useDispatch} from 'react-redux';
import {storeImportExportDetails, saveImportExportApplication} from "../../../redux/actions";
import ScrollToTop from "../../../utils/ScrollToTop";
import { RedirectIfCaptchaNotSelected } from "../../../utils/Redirect";
import {isSelected, validate, scrollToError} from "../../../utils/Validation";

const IndividualnterStateDecision = props => {

    ScrollToTop();
    RedirectIfCaptchaNotSelected(props);

    const importExportDetails = useSelector(state => state.importExportDetails);
    const interStateDetails = useSelector(state => state.interStateDetails);
    const dispatch = useDispatch();

    const [interStateDecisionAppType, setInterStateDecisionAppType] = useState(importExportDetails ? importExportDetails.interStateDecisionAppType : null);
    const [questionAppType, serQuestionAppType] = 
        useState(importExportDetails.ieType === "Export" 
            ? "Provide details of interstate person or business to whom the animals will be exported"
            : "Provide details of interstate person or business from whom the animals will be imported?");

    const applicationTypeValues = [
        {
            value: 'Individual',
            label: 'Individual'
        },
        {
            value: 'Organisation',
            label: 'Organisation'
        }
    ];

    const [showErrors, setShowErrors] = useState(false);

    const validators = [
        {
            fieldName: "interStateDecisionAppType",
            fieldValue: interStateDecisionAppType,
            isValid: (v) => (isSelected(v)),
        },
      ];

    const [errors, setErrors] = useState({
        interStateDecisionAppType: false,
    });

    const storeData = (finished) => {
        const importExportDetailsData = {
            ...importExportDetails,
            interStateDecisionAppType: interStateDecisionAppType,
            interStateDecisionAppTypeStep: 1,
            // interStateDecisionAppTypeFinished: finished
        };

        dispatch(storeImportExportDetails(importExportDetailsData));
    };    

    const continueButtonHandler = () => {

        if (validate(validators, setErrors)) {
            setShowErrors(false);
            storeData(true);
            
            dispatch(
                saveImportExportApplication("", () => {
                    props.history.push(`./interstate-individual`);
                })
            );
            // if(interStateDecisionAppType === 'Individual')
            // {
            //     props.history.push('/import-export/interstate-individual') 
            // } else {
            //     props.history.push('/import-export/interstate-organisation') 
            // }
        } else {
            setShowErrors(true);
            scrollToError();
        }         
           
    }    
    
    return (
        <div className={styles.mainCont}>
            <div className={"row"}>
                <div className={"col-12"}>
                    <label>{questionAppType}</label>
                    <div className={styles.topMargin24}>
                        <RadioSelector
                            options={applicationTypeValues}
                            onSelectionChange={(selectedValue) => {
                                setInterStateDecisionAppType(selectedValue);
                                
                                if (selectedValue === 'Organisation' && interStateDetails.isIndividualValid)
                                {
                                    if(!interStateDetails.organisationIdType || interStateDetails.organisationIdType === '')
                                    {
                                        // var newInterStateDetails = {
                                        //     ...interStateDetails,
                                        //     step: 1,
                                        //     // finished: false
                                        // }
                                        // dispatch(storeInterStateDetails(newInterStateDetails));

                                        const importExportDetailsData = {
                                            ...importExportDetails,
                                            interStateDecisionAppTypeStep: 2,
                                            interStateDecisionAppTypeFinished: false
                                          };
                                      
                                         dispatch(storeImportExportDetails(importExportDetailsData));    

                                    }
                                } 
                                // else {
                                //     if(interStateDetails.isIndividualValid)
                                //     {
                                //         var newInterStateDetails = {
                                //             ...interStateDetails,
                                //             // finished: true
                                //         }
                                //         dispatch(storeInterStateDetails(newInterStateDetails)); 
                                //     }
                                // }
                               
                            }}
                            initialValue={interStateDecisionAppType}
                        />
                    </div>
                </div>
                {interStateDecisionAppType==null && errors.interStateDecisionAppType && showErrors ? (
                    <div className={`col-12 ${styles.errorContainer}`}>
                    <ErrorMsg 
                        className={"ErrorMsg_error"}
                        type={"error"}
                        description={"Please make a selection."}
                    />
                    </div>
                    ) : null}                    
            </div>

            <div className={`row ${styles.buttonCont}`}>
                <div className={`col-12`}>
                    <Button onClick={() => continueButtonHandler()}>
                        Continue
                    </Button>
                    <Button
                        secondary
                        onClick={() => {

                            storeData();
                            dispatch(
                                saveImportExportApplication("", () => {
                                    props.history.push(`./dashboard`);
                                })
                            );

                        }}>
                        Save & exit section
                    </Button>
                </div>
            </div>

            {/* <div className={`row ${styles.buttonCont}`}>
                <div className={`col-12`}>
                    <Button
                    onClick={() => {

                        props.history.push(`./interstate-decision`);

                        // if (validate(validatorsOtherNames, setErrorsOtherNames) && validate(validators, setErrors)) {
                        //   props.history.push(`./employment`);
                        //   setShowErrors(false);
                        //   setShowErrorsOtherNames(false);
                        //   storeData();
                        // } else {
                        //   setShowErrors(true);
                        //   setShowErrorsOtherNames(true);
                        //   scrollToError();
                        // }
                    }}
                    >
                    Continue
                    </Button>

                    <Button
                    secondary
                    onClick={() => {
                        // storeData();
                        // dispatch(
                        //   saveApplication("step1", () => {
                        //     props.history.push(`../tattooist-form/application-saved`);
                        //   })
                        // );
                    }}
                    >
                    Save & exit section
                    </Button>

                </div>
            </div>             */}
        </div>

    );    

    // return <div className={"row"}>
    //     <div className={"col-12"}>
    //     <label className={styles.anotherNameLabel}>
    //         Provide details of interstate person or business from whom the animals will be imported?
    //     </label>
    //     <div className={styles.topMargin24}>
    //         <RadioSelector
    //             options={applicationTypeValues}
    //             onSelectionChange={(selectedValue) => {
    //                 setAppType(selectedValue);              
    //             }}
    //             // initialValue={factSheet}
    //         />
    //     </div>
    //     {/* {errorsMain.employmentFlag && showErrorsMain ? (
    //         <ErrorMsg className={"ErrorMsg_error"}
    //         type={"error"}
    //         description={"Please make a selection."}
    //         />
    //     ) : null} */}

    //     </div>
    // </div>
  
    

};

export default withRouter(props => <IndividualnterStateDecision {...props}/>);
